import { Size } from '@/services/size/Size'
import { Color } from '@/services/color/Color'
import { Technique } from '@/services/technique/Technique'

export class SearchFiltersTranslations {
  sizes: Size[] = []
  colors: Color[] = []
  techs: Array<Partial<Technique>> = []
  themes: Array<{ id: string }> = []
  orientations: Array<{ id: string, name: string }> = []

  constructor(data: Partial<SearchFiltersTranslations> = {}) {
    Object.assign(this, data)
  }
}
